export const GET_CONCEIRGE_CHAT = 'GET_CONCEIRGE_CHAT'
export const GET_RESTAURANT_CHAT = 'GET_RESTAURANT_CHAT'